import { render, staticRenderFns } from "./EmpresaView.vue?vue&type=template&id=cf6bf876&"
import script from "./EmpresaView.vue?vue&type=script&lang=js&"
export * from "./EmpresaView.vue?vue&type=script&lang=js&"
import style0 from "./EmpresaView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports